import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
    const { userAuthState } = useContext(AuthContext);
    return (userAuthState.user && userAuthState.user !== undefined && userAuthState.user !== 'undefined') ? children : <Navigate to="/login" />;
};
export default PrivateRoute
